module.exports = __webpack_public_path__ + "static/media/google-play-badge-crop.8a4320c2.png";